import { injectable, inject } from 'inversify-props';
import { CounterState, types } from '@/store';
import { Store } from 'vuex';
import { UniquePromise } from '@/utils';
import { ICounterApi } from '@/apis';

export interface ISettingService {
  activate(): any;
  loadUserInfo();
}

@injectable()
export class SettingService implements ISettingService {
  @inject() private store!: Store<CounterState>;
  @inject() private counterApi!: ICounterApi;
  private activatePromise = new UniquePromise();
  private loadUserInfoPromise = new UniquePromise();

  async activate() {
    return this.activatePromise.run(async () => {
      await this.loadAppSettings();
    });
  }

  async loadAppSettings() {
    const response = await this.counterApi.getAppSettings();
    if (response.status === 200) {
      this.store.dispatch(types.actions.setAppSettings, response.data);
    }
  }

  async loadUserInfo() {
    this.loadUserInfoPromise.run(async () => {

      const response = await this.counterApi.getUserInfo();
      if (response.status === 200) {
        this.store.commit(types.mutations.updateUserInfo, response.data);
      }

    });
  }
}

export const settingService = new SettingService();
